import type { EntityChunkPayload } from '../gateway/contracts';

export type LegacyBuildingLevitationSurface = Readonly<{
  tileWidth: number;
  tileDepth: number;
  levitation: number;
}>;

export type LegacyBuildingLevitationSurfaceResolver = (
  buildingType: number,
  rotation: number,
) => LegacyBuildingLevitationSurface | undefined;

/**
 * Reproduces the source `Tw.g(float, float)` cell lookup used by `axK.P_()`.
 * Character bounds do not participate: the building occupying the cell beneath
 * the character center contributes its catalog levitation to terrain height.
 */
export function legacyObjectLevitationAt(
  chunks: Iterable<EntityChunkPayload>,
  worldX: number,
  worldZ: number,
  resolveSurface: LegacyBuildingLevitationSurfaceResolver,
): number {
  if (!Number.isFinite(worldX) || !Number.isFinite(worldZ)) return 0;
  const gridX = Math.floor(worldX * 2 + 128);
  const gridZ = Math.floor(worldZ * 2 + 128);
  for (const chunk of chunks) {
    for (const building of chunk.buildings) {
      if (building.consumed || !building.placedOnMap) continue;
      const surface = resolveSurface(building.type, building.rotation);
      if (surface === undefined) continue;
      const minimumX = building.tileX + 128;
      const minimumZ = building.tileZ + 128;
      if (
        gridX >= minimumX &&
        gridX < minimumX + surface.tileWidth &&
        gridZ >= minimumZ &&
        gridZ < minimumZ + surface.tileDepth
      ) {
        return surface.levitation;
      }
    }
  }
  return 0;
}
